// extracted by mini-css-extract-plugin
export default {"recognitions":"recognitions-module--recognitions--lIY+J","recognitionItem":"recognitions-module--recognition-item--bTjtA"};